import { createSelector } from 'reselect';
import { matchPath } from 'react-router-dom';

import routesSelector from './routesSelector';
import getCurrentPath from './getCurrentPath';

const getCurrentRoute = (state, props) => {
    const routes = routesSelector(state, props);
    const currentPath = getCurrentPath(state, props);
    return (
        routes.find(({ path, exact }) =>
            matchPath(currentPath, {
                path,
                exact,
                strict: false,
            }),
        ) || {}
    );
};

export default createSelector(getCurrentRoute, (route) => ({
    route,
}));
